import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/auth/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function logout() {
  return request({
    url: '/admin/auth/logout',
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js